function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var b = Object.defineProperty,
    f = Object.defineProperties;
var h = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var s = function s(r, t, o) {
  return t in r ? b(r, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : r[t] = o;
},
    i = function i(r, t) {
  for (var o in t || (t = {})) {
    c.call(t, o) && s(r, o, t[o]);
  }

  if (l) {
    var _iterator = _createForOfIteratorHelper(l(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        g.call(t, o) && s(r, o, t[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return r;
},
    m = function m(r, t) {
  return f(r, h(t));
};

var n = function n(r, t) {
  var o = {};

  for (var e in r) {
    c.call(r, e) && t.indexOf(e) < 0 && (o[e] = r[e]);
  }

  if (r != null && l) {
    var _iterator2 = _createForOfIteratorHelper(l(r)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;
        t.indexOf(e) < 0 && g.call(r, e) && (o[e] = r[e]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return o;
};

import u, { forwardRef as y } from "react";
import d from "classnames";
import { ButtonStyled as p } from "../buttons";
var N = y(function (e, o) {
  var a = e,
      r = a.className,
      t = n(a, ["className"]);
  return u.createElement(p, m(i({}, t), {
    ref: o,
    className: d(["lc-button-default", "lc-text-gray-darker", "lc-bg-gray-lighter", "lc-border-gray-lighter", "hover:lc-text-black", "hover:lc-bg-gray-light", "hover:lc-border-gray-light", "focus-visible:lc-ring-gray-lighter"], r)
  }));
});
export { N as Button };